// extracted by mini-css-extract-plugin
module.exports = {"textWithSubheading":"styles_textWithSubheading__1WPlG","title":"styles_title__1zScU","contents-heading":"styles_contents-heading__LPlZw","browser-ie":"styles_browser-ie__VQGt7"};